// extracted by mini-css-extract-plugin
module.exports = {"sponsoredBanner":"kn-z","sponsoredTooltipWrapper":"ln-z","sponsoredTooltip":"mn-z","newCard":"nn-z"};